const crypto = require("crypto");
const dayjs = require('dayjs')
// import store from "../store";
// import MansionService from "../services/mansion.service"
export default {
  computed: {
    labels() {
      return this.$store.state.settings.labels;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    mcCode() {
      return this.currentUser
        ? this.currentUser.mansion
          ? this.currentUser.mansion._id
          : ""
        : "";
    },
    mansion() {
      // console.log("++ mixin mansion");
      // console.log(this.$store.state.mansion.data);
      return this.$store.state.mansion.data;
    },
    roleCode() {
      if (!this.currentUser) {
        return "";
      }
      const admins = ["SuperAdmin", "Admin", "AreaAdmin"];
      if (admins.indexOf(this.currentUser.role) != -1) {
        return "1000";
      } else if (this.currentUser.role == "RentResident") {
        return "0000";
      } else {
        return "0100";
      }
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log("+++ mixin:beforeRouteEnter");
  //   const currentUser = store.state.auth.user;
  //   console.log(currentUser);
  //   console.log(to);

  //   if (currentUser != null && currentUser.mansion._id != to.params.mc_code) {
  //     console.log(":401");
  //     next({
  //       name: "notfound404",
  //       params: { mc_code: currentUser.mansion._id },
  //     });
  //   } else {
  //     next();
  //   }
  // },
  methods: {
    createTitleDesc: function(routeInstance) {
      // タイトルを設定
      if (routeInstance.meta.title) {
        var setTitle =
          routeInstance.meta.title + ` | ${this.currentUser.mansion.name}`;
        document.title = setTitle;
      } else {
        document.title = this.currentUser.dai_bunrui.name;
      }
      // メタタグのdescription設定処理
      console.log("meta", routeInstance.meta);
      if (routeInstance.meta.desc) {
        var setDesc = routeInstance.meta.desc + "";
        document
          .querySelector("meta[name='description']")
          .setAttribute("content", setDesc);
      } else {
        document
          .querySelector("meta[name='description']")
          .setAttribute("content", "");
      }
    },
    commentDate(createdAt) {
      const date = dayjs(createdAt).tz().format("YYYY/MM/DD");
      const today = dayjs().tz().format("YYYY/MM/DD");
      // console.log("commentDate");
      // console.log(createdAt);
      // console.log(date);
      // console.log(today);
      if (date == today) {
        return "";
      } else {
        return dayjs(createdAt).tz().format("MM/DD");
      }
    },
    commentTime(createdAt) {
      return dayjs(createdAt).tz().format("HH:mm");
    },
    isPermission(value) {
      return this.$store.getters["auth/isPermission"](value);
    },
    isOfficialWord(value) {
      return value ? "" : "予定";
    },
    md5hex(str /*: string */) {
      const md5 = crypto.createHash("md5");
      return md5.update(str, "binary").digest("hex");
    },
    createTag(tag) {
      const str = this.labels[tag] ? this.labels[tag] : "";
      return `<span class="c-newsTag ${tag}" style="margin-left: 1rem;">${str}</span>`;
    },
    statusText(tag) {
      return this.labels[tag] ? this.labels[tag] : "";
    },
    toYYYYMMDD(str) {
      // console.log("+++ toYYYYMMDD");
      if (str != undefined) {
        return dayjs(str).tz().format("YYYY/MM/DD");
      } else {
        return "";
      }
    },

    toTIMESTAMP(str, hhmm) {
      // console.log("+++ toYYYYMMDD");
      if (str != undefined) {
        return dayjs(str).tz().format("YYYY/MM/DD") + ` ${hhmm}`;
      } else {
        return "";
      }
    },
    currentDate() {
      return dayjs().tz().format("YYYY/MM/DD HH:mm");
    },
    contentsLoader(id, url) {
      var req = new XMLHttpRequest();
      const method = "GET";
      // const file = "/mc/docs/kiyaku_pre.html";

      var div = document.getElementById(id);

      req.open(method, url, true);
      req.onreadystatechange = function() {
        if (req.readyState === 4 && req.status === 200) {
          var rest = req.responseText;
          div.innerHTML = rest;
        }
      };
      req.send();
    },
    hashEmailAddress(email) {
      if (!email) return "";
      const temp = email.split("@");
      const len = temp[0].length;
      if (len < 3) {
        return `${temp[0]}@${temp[1]}`;
      } else {
        const maru = "●".repeat(len - 2);
        const pre = temp[0].substr(0, 2);
        return `${pre}${maru}@${temp[1]}`;
      }
    },
    appendFile() {
      console.log("+++ appendFile");
      if (this.currentUser != null && this.currentUser.mansion != undefined) {
        const mansion = this.currentUser.mansion;
        const dai_bunrui = mansion.dai_bunrui;
        const chu_bunrui = mansion.chu_bunrui;
        const mc_code = mansion._id;
        // console.log(this.currentUser);
        this.appendCSS(`/assets/custom/${dai_bunrui}/default.css`);
        this.appendJS(`/assets/custom/${dai_bunrui}/default.js`);
        this.appendCSS(
          `/assets/custom/${dai_bunrui}/${chu_bunrui}/default.css`,
        );
        this.appendJS(`/assets/custom/${dai_bunrui}/${chu_bunrui}/default.js`);
        this.appendCSS(
          `/assets/custom/${dai_bunrui}/${chu_bunrui}/${mc_code}/default.css`,
        );
        this.appendJS(
          `/assets/custom/${dai_bunrui}/${chu_bunrui}/${mc_code}/default.js`,
        );
        document.body.classList.add(dai_bunrui);
        document.body.classList.add(chu_bunrui);
        document.body.classList.add(mc_code);
        document.body.classList.add(this.currentUser.roomNo);
        document.body.classList.add(this.currentUser.status);
        if (mansion.iuc_code) {
          document.body.classList.add(mansion.iuc_code);
        }
        if (mansion.ipd_code) {
          document.body.classList.add(mansion.ipd_code);
        }

        document.body.classList.add(this.currentUser.role);
      }
    },
    appendJS(filePath) {
      let file2 = document.createElement("script");
      file2.type = "text/javascript";
      file2.src = filePath;
      document.head.appendChild(file2);
    },
    statusToLabel(status) {
      const statusLabel = {
        contractor: "契約者",
        resident: "入居者",
        others: "その他",
      };
      return statusLabel[status];
    },
  },
};
